import React, {useEffect, useRef, useState} from 'react';
import FormInput from "./Inputs/FormInput/FormInput";
import PropTypes from 'prop-types';
import icons from "../assets/icons";
import styled from "styled-components";

LiveSearchInput.propTypes = {
    optionClickHandler: PropTypes.func,
    onChange: PropTypes.func,
    storage: PropTypes.arrayOf(PropTypes.shape({
            show: PropTypes.string,
            id: PropTypes.string
        }
    ))
};


function LiveSearchInput(props) {
    const [helperShow, setHelperShow] = useState();
    const inputRef = useRef()


    useEffect(() => {
        props.onChange(props.initialValue)
        props.storage[0] && props.optionClickHandler({
            name: props.storage[0],
            id: props.storage[0].id,
            all: props.storage[0]
        })
    }, [])

    useEffect(() => {

        if (!inputRef?.current?.value || !inputRef?.current?.value === "" ) {
            props.optionClickHandler({
                name: " ",
                id: null,
                all: {}
            })
        }

    }, [inputRef?.current?.value])

    return (
        <Styled className={"live-Search"} icon={props.icon}>

            <FormInput
                name={props.name}
                title={props.title}
                id={props.name}
                defaultValue={props.initialValue}
                reff={inputRef}
                onChange={e => props.onChange(e.target.value)}
                className={`live-Search__input`}
                disabled={props.disabled}
                important={props.important}
                hideIcon={true}
                placeholder={props.placeholder}
                onFocus={_ => setHelperShow(true)}
                onBlur={_ => setTimeout(() => setHelperShow(false), 500)}
            />

            {helperShow &&
            <div className={'live-Search__Dropdown-Helper'} style={{maxHeight: props.maxHeight + 'px'}}>
                {props.storage && props.storage.map(option => {

                    return <div
                        onClick={e => {
                            props.optionClickHandler({name: e.target.innerText, id: e.target.id, all: option})
                            inputRef.current.value = option.show
                        }}
                        id={option.id}
                        key={option.id}
                        className="live-Search__Dropdown-Helper__option">{option.show}</div>
                })}
            </div>}
            {props.icon === 'search' && <img className={"icon"} src={icons.search} alt="d"/>}
        </Styled>
    );
}

const Styled = styled.div`
  width: 100%;
  position: relative;

  input {
    padding-left: ${p => p.icon ? "50px" : ""};
  }

  .icon {
    position: absolute;
    left: 16px;
    top: 20px;
    @media (max-width: 1100px) {
      top: 10px
    }
  }

  &__Dropdown-Helper {
    min-width: 100%;
    background: white;
    min-height: 0;
    max-height: 190px;
    overflow: scroll;
    position: absolute;
    top: 85px;
    box-shadow: 0px 3px 6px 0px rgba(39, 45, 59, 0.2);
    border-radius: 10px;
    z-index: 100;
  }

  &__option {
    padding: 10px;
    border-bottom: 1px solid rgba(154, 154, 154, 0.47);
    cursor: pointer;
    font-size: 14px;

    &:hover {
      background: rgba(39, 139, 154, 0.1)
    }
  }


`
export default LiveSearchInput;